import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import React, { useContext } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { NotificationAction } from '../notificationContext/NotificationActionProvider'
import * as R from 'ramda'
import clsx from 'clsx'
import {
  useTooltipTitle,
  TooltipStatus,
} from 'app/main/messages/notificationTimeline/status/TooltipStatus'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { isUnsent } from 'app/main/messages/notificationTimeline/unsendNotification/unsendNotificationLogic'
import { useSelector } from 'react-redux'
import useMessageExpiration from 'commons/useMessageExpiration'

const useStyles = makeStyles((theme) => ({
  actionText: {
    paddingTop: '2px',
    color: theme.palette.secondary.main,
  },
  negativeText: {
    color: theme.palette.negative.main,
  },
}))
const UnsendNotificationButton = ({ notification }) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const { unsend } = useContext(NotificationAction)
  const { id } = useSelector(({ auth }) => auth.user.data)
  const createTooltipTitle = useTooltipTitle()
  const messageExpiration = useMessageExpiration(notification)

  if (messageExpiration.hasExpired) {
    return null
  }

  if (isUnsent(notification)) {
    const performDate = R.prop('unsentDate', notification)
    const person = R.prop('unsentBy', notification)
    const titleObj = createTooltipTitle(person, performDate)

    const title = formatMessage(
      { id: 'notificationTimeline.card.unsentBy.title' },
      titleObj,
    )

    return (
      <TooltipStatus
        title={title}
        status={
          <FormattedMessage id="notificationTimeline.card.status.unsent" />
        }
      />
    )
  } else {
    return (
      <AccessControl accesses={[AccessType.ADMINISTRATION]}>
        {(isGrantedAdmin) => (
          <AccessControl accesses={[AccessType.NOTIFICATION_UNSENT_OWNED]}>
            {(isGrantedUnsent) =>
              R.or(
                isGrantedAdmin,
                R.and(
                  isGrantedUnsent,
                  R.equals(R.prop('posterId', notification), id),
                ),
              ) && (
                <div className="flex cursor-pointer">
                  <Typography
                    className={clsx(
                      classes.actionText,
                      'text-xs font-semibold hover:underline',
                    )}
                    onClick={() => unsend(notification)}
                  >
                    <FormattedMessage id="notificationTimeline.card.action.unsend" />
                  </Typography>
                </div>
              )
            }
          </AccessControl>
        )}
      </AccessControl>
    )
  }
}

export default React.memo(UnsendNotificationButton)
